const LoaderInvitations = () => {
  return (
    <div className="flex flex-col gap-10">
      {Array.from({ length: 15 })?.map((_, index) => {
        return (
          <div key={index} className="flex gap-3 w-full justify-between">
            <div className="flex flex-col gap-2">
              <div className="bg-gray-300 h-3.5 w-40 animate-pulse rounded-md"></div>
              <div className="bg-gray-300 h-2 w-32 animate-pulse rounded-md"></div>
              <div className="bg-gray-300 h-2 w-28 animate-pulse rounded-md"></div>
            </div>
            <div className="flex gap-4">
              <div className="bg-gray-300 h-14 w-14 animate-pulse rounded-full"></div>
              <div className="flex flex-col gap-2">
                <div className="bg-gray-300 h-3.5 w-40 animate-pulse rounded-md"></div>
                <div className="bg-gray-300 h-2 w-32 animate-pulse rounded-md"></div>
                <div className="bg-gray-300 h-2 w-28 animate-pulse rounded-md"></div>
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="bg-gray-300 h-3.5 w-40 animate-pulse rounded-md"></div>
              <div className="bg-gray-300 h-2 w-32 animate-pulse rounded-md"></div>
              <div className="bg-gray-300 h-2 w-28 animate-pulse rounded-md"></div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LoaderInvitations;
